import { Stack, Button, Box, IconButton } from "@mui/material";
import { GridSortModel } from "@mui/x-data-grid";
import { Text } from "@imminently/react/ui/core/text";
import { createColumn, Params, ServerList } from "@imminently/react/ui/resource/list";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { PageTitle } from "@/components/PageTitle";
import { UserAccount } from "@/resources/types";
import { useCreateUserModal, useEditUserModal } from "@/modals/addOrEditUser";
import { useUsers } from "@/resources/users";

type UserParams = Params<UserAccount>;

const initialSort: GridSortModel = [{ field: "first_name", sort: "asc" }];

const NameColumn = ({ row }: UserParams) => {
  return (
    <Text variant="body1">
      {row.firstName} {row.lastName}
    </Text>
  );
};


const ActionsColumn = ({ row }: UserParams) => {
  const openEditModal = useEditUserModal();

  const onEdit = () => {
    openEditModal({ id: row.id });
  }
  return (
    <>
      <IconButton onClick={onEdit}>
        <ModeEditIcon />
      </IconButton>
      <IconButton disabled>
        <DeleteIcon />
      </IconButton>
    </>
  );
};

const clientColumns = [
  createColumn({ field: "name", headerName: "Name", sortable: true, renderCell: NameColumn }),
  createColumn({ field: "email", headerName: "Email", sortable: true }),
  createColumn({ field: "role", headerName: "Role", sortable: true, flex: 0.5 }),
  createColumn({ field: 'id', headerName: 'Actions', sortable: false, flex: 0.3, renderCell: ActionsColumn })
];

export const Accounts = () => {
  const openCreateModal = useCreateUserModal();

  return (
    <Stack flex={1}>
      <PageTitle title="Users">
        <Box flex={1} />
        <Button onClick={() => openCreateModal({})}>
          Add User
        </Button>
      </PageTitle>
      <Stack px={3} pb={3} flex={1}>
        <ServerList
          sx={{ flex: 1, width: "100%" }}
          resource='users'
          columns={clientColumns}
          initialSort={initialSort}
        />
      </Stack>
    </Stack>
  );
};